import { z } from 'zod';
import { teamColors } from '@scoreboard/design-tokens';

// Palette fermée de 16 couleurs (doc 05 §3.1) : l'appartenance est validée en zod ici,
// pas en CHECK SQL — la palette peut évoluer sans migration (doc 04 §1.4).
export const TEAM_COLOR_HEXES = teamColors.map((c) => c.hex) as [string, ...string[]];

export const teamColorHexSchema = z
  .string()
  .trim()
  .toUpperCase()
  .refine((hex) => TEAM_COLOR_HEXES.includes(hex), 'COLOR_NOT_IN_PALETTE');
